import { deepFind } from '@/utils/find'

export default {
  // ローカルデータをクリーンアップする。Appだけでなく他モジュールのクリーンアップもコールする。
  clearAppData ({ commit, dispatch }) {
    commit('setUser', { id: null, name: null, roleId: null })
    commit('setCompany', { id: null, name: null })
    commit('setDeliveryGroupId', null)
    commit('setShowQuestionnaire', false)
    dispatch('dashboard/clearData', null, { root: true })
    dispatch('list/clearData', null, { root: true })
    dispatch('customers/clearData', null, { root: true })
    dispatch('groups/clearData', null, { root: true })
    dispatch('tankTypes/clearTankTypes', null, { root: true })
  },

  // 必要なAPIをコールしローカルデータを初期化する。取得したユーザー情報に応じて他モジュールの初期化をする。
  async initAppData ({ commit, dispatch }) {
    const group = await dispatch('groups/initGroupData', { init: true }, { root: true })
    if (!group) return

    dispatch('dashboard/init', group.id, { root: true })
    dispatch('list/getHeaders', null, { root: true })
    commit('customers/setFieldProp', { area: group.id }, { root: true })
    dispatch('tankTypes/setTankTypes', null, { root: true })

    if (isCompany(group)) {
      const areaId = findFirstArea(group)
      dispatch('list/setArea', areaId, { root: true })
    } else {
      dispatch('list/setArea', group.id, { root: true })
    }

    commit('setInitialized', true)
  },

  // ユーザー情報を保存する。
  setUserInfo ({ commit }, { id, name, roleId, company, deliveryGroupId }) {
    commit('setCompany', company)
    commit('setUser', { id, name, roleId })
    commit('setDeliveryGroupId', deliveryGroupId)
  },

  setConfig ({ commit }, config) {
    commit('setConfig', config)
  }
}

/**
 * HELPER FUNCTIONS
 */
const isCompany = group => (group.type === 'company' || group.type === 'main_company')

// とにかく一番最初のエリアを取得してくるパターン -> 採用中
const findFirstArea = group => {
  const res = deepFind([group], g => g.type === 'area')
  return res?.id
}
